module.exports = __webpack_public_path__ + "assets/1714848bc596781d0d0667941ccbbbfcb.jpg";